import React from "react";
import { ProjectAdminConfig } from "../components/features/ProjectAdminConfig/ProjectAdminConfig";

export const ProjectAdminConfigScreen = () => {
    return(
        <ProjectAdminConfig/>   
    )
}